/**
 * Based on store.ts
 * @link https://gist.github.com/koenbok/ae7b94f9fefccc16a34589af344db789
 * @link https://www.framer.com/blog/posts/react-components-state/
 */

import { useState, useEffect } from 'react';

export default function createStore(state) {
  let storeState = Object.assign({}, state);
  const storeSetters = new Set();

  const setStoreState = state => {
    storeState = Object.assign({}, storeState, state);
    storeSetters.forEach(setter => setter(storeState));
  };

  function useStore() {
    const [state, setState] = useState(storeState);
    useEffect(() => () => storeSetters.delete(setState), []);
    storeSetters.add(setState);
    return [state, setStoreState];
  }

  return useStore;
}
